import React, { useState, useEffect } from 'react';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import GridDefaultShimmer from '../../../../components/GridDefaultShimmer/GridDefaultShimmer';
import ColEdit from '../../../../components/ColEdit/ColEdit';
import ExtraTypeNew from './New/ExtraTypeNew';
import { API } from '../../../../API/API';
import GridColCheck from '../../../../components/GridColCheck/GridColCheck';
import { useContext } from 'react';
import { UserContext } from '../../../../context/UserContext';
import { isEdit } from '../../../../SharedFunc/User';

const ExtraType = (props) => {

    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [columns, setColumns] = useState([{
        name: 'Төрлийн нэр',
        fieldName: 'name',
        onRender: (item) => {
            if (edit) {
                return (
                    <ColEdit onClick={() => onEdit(item.extratypeid)}>{item.name}</ColEdit>
                );
            } else {
                return item.name;
            }
        }
    }, {
        name: 'Төрд ажилласан жилээр',
        fieldName: 'isgovyear',
        onRender: (item) => {
            return (
                <GridColCheck disable={false} defaultValue={item.isgovyear} />
            );
        }
    }, {
        name: 'Идэвхтэй',
        fieldName: 'isactive',
        onRender: (item) => {
            return (
                <GridColCheck disable={false} defaultValue={item.isactive} />
            );
        }
    }]);
    const [loading, setLoading] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [extratypeid, setExtraTypeId] = useState();

    const [edit] = useState(isEdit(userInfo?.accesstoken, ["HR", "MANAGER"]));


    const getData = async () => {
        let tData = [];
        await API.get('/api/humanresource/payroll/get_extra_type_list').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, []);

    const onNew = () => {
        setExtraTypeId();
        setShowNew(true);
    }

    const onEdit = (p_id) => {
        setExtraTypeId(p_id);
        setShowNew(true);
    }

    const onDismiss = () => {
        setExtraTypeId();
        setShowNew(false);
    }

    const afterSave = async () => {
        getData();
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title={'Нэмэгдлийн төрөл (' + data?.length + ')'}
                buttonTitle={edit ? 'Нэмэгдлийн төрөл нэмэх' : null}
                onButtonClick={onNew}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                setKey='extratypeid'
                loading={loading}
                columns={columns}
                data={data}
            />
            <ExtraTypeNew
                extratypeid={extratypeid}
                isOpen={showNew}
                onDismiss={onDismiss}
                afterSave={afterSave}
            />
        </div>
    );
}

export default ExtraType;